import { client } from './client';
import { endpoints } from './endpoints';

export type Menu = {
  menuUUID: string;
  nameAr: string;
  nameEn: string;
};

export async function fetchBranchMenus(branchUUID: string): Promise<Menu[]> {
  const response = await client.get(endpoints.BRANCH_MENUS(branchUUID));

  return response.data;
}
